<template>
    <div
        class="relative flex items-center w-full col-span-1 px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
    >
        <div
            @click="show = !show"
            class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900"
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto">
                <div class="flex justify-between" v-show="show">
                    <h2
                        ref="scrollToMe"
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ tools.designation }}
                    </h2>
                    <div @click="removeTools">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8 cursor-pointer"
                            icon-name="trash"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <tag-group :tags="tags" @clicked="changeIsBuyingType" />
                    <base-input
                        placeholder="Désignation"
                        v-model="tools.designation"
                        :hasError="$v.tools.designation.$error"
                        :errorMessage="
                            errorMessage('Désignation', $v.tools.designation)
                        "
                        @blur="$v.tools.designation.$touch()"
                    />
                    <base-number-input
                        label="Quantité"
                        placeholder="0"
                        v-model="tools.number"
                        :hasError="$v.tools.number.$error"
                        :errorMessage="errorMessage('Nombre', $v.tools.number)"
                        @blur="$v.tools.number.$touch()"
                    />
                    <base-input
                        placeholder="Caractéristiques"
                        v-model="tools.characteristics"
                        :hasError="$v.tools.characteristics.$error"
                        :errorMessage="
                            errorMessage(
                                'Caractéristiques',
                                $v.tools.characteristics
                            )
                        "
                        @blur="$v.tools.characteristics.$touch()"
                    />
                    <div class="mt-10 ml-3 text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >État</label
                        >
                        <radio-box
                            label="Neuf"
                            name="buyingOrRent"
                            :value="tools.state"
                            @change="
                                payload => {
                                    tools.state = payload;
                                }
                            "
                        />
                        <radio-box
                            class="ml-6"
                            label="Occasion"
                            name="buyingOrRent"
                            :value="tools.state"
                            @change="
                                payload => {
                                    tools.state = payload;
                                }
                            "
                        />
                    </div>
                    <base-number-input
                        :isCurrency="true"
                        label="Prix Unitaire (HT)"
                        placeholder="0"
                        v-model="tools.price"
                        :hasError="$v.tools.price.$error"
                        :errorMessage="errorMessage('Prix', $v.tools.price)"
                        @blur="$v.tools.price.$touch()"
                    />

                    <base-input
                        placeholder="Nom du fournisseur"
                        v-model="tools.providerName"
                        :hasError="$v.tools.providerName.$error"
                        :errorMessage="
                            errorMessage(
                                'Nom du fournisseur',
                                $v.tools.providerName
                            )
                        "
                        @blur="$v.tools.providerName.$touch()"
                    />
                    <div class="mt-10 ml-3 text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Origine</label
                        >
                        <radio-box
                            label="Local"
                            name="origine"
                            :value="tools.origin"
                            @change="
                                payload => {
                                    tools.origin = payload;
                                }
                            "
                        />
                        <radio-box
                            class="ml-6"
                            label="Étranger"
                            name="origine"
                            :value="tools.origin"
                            @change="
                                payload => {
                                    tools.origin = payload;
                                }
                            "
                        />
                    </div>
                    <base-tips-alert
                        v-if="!tools.isBuying"
                        color="bg-orange-100 border-orange-400"
                        title="Attention"
                    >
                        <p class="my-0 mt-1 text-gray-700">
                            Veuillez contacter votre banquier pour avoir la
                            simulation de votre crédit de bail.
                        </p>
                    </base-tips-alert>
                    <base-number-input
                        :isCurrency="true"
                        label="Avance (HT)"
                        placeholder="0"
                        v-if="!tools.isBuying"
                        v-model="tools.payedInAdvance"
                        :hasError="$v.tools.payedInAdvance.$error"
                        :errorMessage="
                            errorMessage('Avance (HT)', $v.tools.payedInAdvance)
                        "
                        @blur="$v.tools.payedInAdvance.$touch()"
                    />
                    <base-number-input
                        :isCurrency="true"
                        label="Loyer mensuel (HT)"
                        placeholder="0"
                        v-if="!tools.isBuying"
                        v-model="tools.rentPrice"
                        :hasError="$v.tools.rentPrice.$error"
                        :errorMessage="
                            errorMessage(
                                'Loyer mensuel  (HT)',
                                $v.tools.rentPrice
                            )
                        "
                        @blur="$v.tools.rentPrice.$touch()"
                    />
                    <base-number-input
                        label="Nombre de mois"
                        placeholder="0"
                        v-if="!tools.isBuying"
                        v-model="tools.rentDuration"
                        :hasError="$v.tools.rentDuration.$error"
                        :errorMessage="
                            errorMessage(
                                'Nombre de mois',
                                $v.tools.rentDuration
                            )
                        "
                        @blur="$v.tools.rentDuration.$touch()"
                    />

                    <div class="flex justify-end mt-4 ">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeTools"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadioBox from "@/components/forms/Toggles/radioBox";
import TagGroup from "@/components/forms/TagGroup";
import IconTrash from "@/components/icons/trash";
import {
    required,
    integer,
    decimal,
    minLength,
    maxLength,
    minValue
} from "vuelidate/lib/validators";

import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToRef } from "@/mixins/scrollToMixin.js";

export default {
    components: { RadioBox, TagGroup, IconTrash },
    props: {
        data: {
            type: Object
        },

        title: {
            type: String
        }
    },

    mixins: [errorMessage, scrollToRef],

    validations() {
        if (this.tools.isBuying) {
            return {
                tools: {
                    price: { required, decimal, minValue: minValue(0) },
                    designation: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    },
                    number: { integer, minValue: minValue(1) },
                    characteristics: {
                        minLength: minLength(3),
                        maxLength: maxLength(150)
                    },
                    providerName: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    }
                }
            };
        } else {
            return {
                tools: {
                    price: { required, decimal, minValue: minValue(0) },
                    rentPrice: { required, decimal, minValue: minValue(0) },
                    rentDuration: { required, integer, minValue: minValue(0) },
                    payedInAdvance: {
                        required,
                        decimal,
                        minValue: minValue(0)
                    },
                    designation: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    },
                    number: { integer, minValue: minValue(1) },
                    characteristics: {
                        minLength: minLength(3),
                        maxLength: maxLength(150)
                    },
                    providerName: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    }
                }
            };
        }
    },
    mounted() {
        this.tags.forEach(elem => {
            if (elem.value === (this.tools.isBuying ? "achat" : "leasing"))
                elem.isActive = true;
        });
    },
    data() {
        return {
            tools: this.data,
            show: false,
            tags: [
                {
                    name: "Achat en propriété",
                    value: "achat",
                    isActive: false
                },
                { name: "Achat en leasing", value: "leasing", isActive: false }
            ]
        };
    },
    methods: {
        changeIsBuyingType(newValue) {
            this.tools.isBuying = newValue === "achat" ? true : false;
        },

        removeTools() {
            this.$emit("remove", this.tools.id);
        },
        createTools() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch("EtudeTechnique/createTools", this.tools);
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        }
    }
};
</script>

<style></style>
